import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SDKUserSelector = () => {
  const { t } = useTranslation();
  

  return (
    <div className="content">
      <div className="titleCell">
        <span>{t("userSelector.userSelectorTitle")}</span>
      </div>
      <br />
      <div className="selectorContent">
        <Link to="/user-check" state={{ type: "fl", navigationPath: "/sdk-form", titleKey: "SDKUserForm.titleRegistration" }}>
          <button
            id="btn-sel"
            name="rcfield:0:checkCompanyButton"
            className="new-blue-btn-sel"
            type="submit"
            role="button"
            aria-disabled="false"
          >
            <span className="ui-button-text ui-c">
              {t("userSelector.flButton")}
            </span>
          </button>
        </Link>
        <Link to="/user-check" state={{ type: "ul", navigationPath: "/sdk-form", titleKey: "SDKUserForm.titleRegistration" }}>
          <button
            id="btn-sel"
            name="rcfield:0:checkCompanyButton"
            className="new-blue-btn-sel"
            type="submit"
            role="button"
            aria-disabled="false"
          >
            <span className="ui-button-text ui-c">
              {t("userSelector.ulButton")}
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default SDKUserSelector;
